module.exports = __webpack_public_path__ + "static/media/bd-1.03832ed5.jpg";